import type { NavKey } from "../components/nav";
import ScreenHeader from "../components/ScreenHeader";

/** 中身がまだ無い画面。見出しと、何がここに来るのかだけを置く */
export default function Placeholder({ navKey, note }: { navKey: NavKey; note: string }) {
  return (
    <>
      <ScreenHeader navKey={navKey} />
      <div className="flex flex-1 items-center justify-center p-10">
        <p className="max-w-xs text-center text-sm text-[var(--color-sub)]">{note}</p>
      </div>
    </>
  );
}
